// Re-applies anchor scroll after the page (and lazy-loaded images) finish
// loading. Browsers fire the initial anchor jump before images load, which
// causes the cert sections to drift out of view as the hero/logo images
// expand the layout. This re-scrolls once everything has settled.
(function () {
  if (!location.hash) return;
  const id = decodeURIComponent(location.hash.slice(1));
  if (!id) return;

  function rescroll() {
    const target = document.getElementById(id);
    if (target) target.scrollIntoView({ block: 'start', behavior: 'auto' });
  }

  if (document.readyState === 'complete') {
    requestAnimationFrame(rescroll);
  } else {
    window.addEventListener('load', () => requestAnimationFrame(rescroll), { once: true });
  }
})();
